package io.horion.cv.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.width
import io.horion.cv.models.PersonalizedSectionType
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.silk.components.text.SpanText
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import androidx.compose.runtime.DisposableEffect
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronDown
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronUp
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.styles.DropdownItemStyle
import io.horion.cv.styles.PersonalizedButtonStyle
import io.horion.cv.styles.PersonalizedChevronStyle
import io.horion.cv.styles.PersonalizedIconStyle
import io.horion.cv.styles.PersonalizedTextStyle
import org.w3c.dom.events.Event
import org.w3c.dom.Node

@Composable
fun PersonalizedSectionButton(
    onClick: (PersonalizedSectionType) -> Unit
) {
    var isDropdownOpen by remember { mutableStateOf(false) }
    var openUpwards by remember { mutableStateOf(false) }
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val chevronIcon = when {
        isDropdownOpen && isDark -> "/chevron-up.svg"
        isDropdownOpen && !isDark -> "/chevron-up1.svg"
        !isDropdownOpen && isDark -> "/chevron-down.svg"
        else -> "/chevron-down1.svg"
    }

    DisposableEffect(isDropdownOpen) {
        if (!isDropdownOpen) return@DisposableEffect onDispose { }

        val listener: (Event) -> Unit = { event ->
            val target = event.target as? Node
            val container = document.getElementById("personalized-button-container")

            if (container != null && target != null && !container.contains(target)) {
                isDropdownOpen = false
            }
        }

        document.addEventListener("click", listener)
        window.addEventListener("scroll", listener)

        onDispose {
            document.removeEventListener("click", listener)
            window.removeEventListener("scroll", listener)
        }
    }

    Box(
        modifier = Modifier
            .id("personalized-button-container")
            .position(Position.Relative)
            .styleModifier {
                property("display", "inline-block")
                property("max-width", "100%")
                property("overflow", "visible")
                property("z-index", "1050")
            }
    ) {
        // Bouton principal
        Box(
            modifier = PersonalizedButtonStyle.toModifier()
                .border(1.px, LineStyle.Solid, if (isDark) Colors.border else Colors.Primary)
                .borderRadius(7.px)
                .cursor(Cursor.Pointer)
                .onClick {
                    val button = document.getElementById(
                        "personalized-button-container"
                    )

                    if (button != null) {
                        val rect = button.getBoundingClientRect()

                        val menuHeight = 230.0
                        val margin = 8.0

                        val spaceBelow =
                            window.innerHeight.toDouble() - rect.bottom

                        val spaceAbove = rect.top

                        openUpwards =
                            spaceBelow < menuHeight + margin &&
                                    spaceAbove > spaceBelow
                    }

                    isDropdownOpen = !isDropdownOpen
                },
            contentAlignment = Alignment.Center
        ) {
            Row(
                modifier = Modifier.fillMaxSize(),
                verticalAlignment = Alignment.CenterVertically
            ) {

                FaPlus(
                    modifier = PersonalizedIconStyle.toModifier()
                        .color(if (isDark) Colors.White else Colors.Primary)
                )

                Box(Modifier.width(5.px))

                SpanText(
                    text = "Rubrique personnalisée",
                    modifier = PersonalizedTextStyle.toModifier()
                        .color(if (isDark) Colors.White else Colors.Primary)
                        .fontFamily(INTER)
                        .fontWeight(FontWeight.SemiBold)
                        .fillMaxWidth()
                )

                Box(Modifier.width(5.px))


                if (isDropdownOpen) {
                    FaChevronUp(
                        modifier = PersonalizedChevronStyle.toModifier()
                            .color(if (isDark) Colors.White else Colors.Primary)
                    )
                } else {
                    FaChevronDown(
                        modifier = PersonalizedChevronStyle.toModifier()
                            .color(if (isDark) Colors.White else Colors.Primary)
                    )
                }
            }
        }

        if (isDropdownOpen) {
            Box(
                modifier = Modifier
                    .position(Position.Absolute)
                    .styleModifier {
                        property("left", "0")
                        property("right", "auto")
                        property("z-index", "1100")
                        property("overflow", "visible")
                        property("box-sizing", "border-box")
                        property("min-width", "100%")

                        if (openUpwards) {
                            property("top", "auto")
                            property("bottom", "calc(100% + 5px)")
                        } else {
                            property("top", "calc(100% + 5px)")
                            property("bottom", "auto")
                        }
                    }
                    .fillMaxWidth()
                    .backgroundColor(
                        if (isDark) Colors.DarkBG else Colors.White
                    )
                    .border(
                        1.px,
                        LineStyle.Solid,
                        if (isDark) Colors.border else Colors.LightGray
                    )
                    .borderRadius(7.px)
                    .boxShadow(
                        offsetX = 0.px,
                        offsetY = 4.px,
                        blurRadius = 10.px,
                        color = rgba(0, 0, 0, 0.3)
                    )
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(8.px)
                ) {
                    DropdownItem(
                        text = "Description",
                        onClick = {
                            onClick(PersonalizedSectionType.DESCRIPTION)
                            isDropdownOpen = false
                        }
                    )

                    DropdownItem(
                        text = "Entrées",
                        onClick = {
                            onClick(PersonalizedSectionType.ENTRIES)
                            isDropdownOpen = false
                        }
                    )

                    DropdownItem(
                        text = "Compétences",
                        onClick = {
                            onClick(PersonalizedSectionType.COMPETENCES)
                            isDropdownOpen = false
                        }
                    )

                    DropdownItem(
                        text = "Liste",
                        onClick = {
                            onClick(PersonalizedSectionType.LIST)
                            isDropdownOpen = false
                        }
                    )
                }
            }
        }
    }
}

@Composable
fun DropdownItem(
    text: String,
    onClick: () -> Unit
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    Box(
        modifier = DropdownItemStyle.toModifier()
            .padding(leftRight = 12.px)
            .borderRadius(4.px)
            .cursor(Cursor.Pointer)
            .onClick { onClick() },
        contentAlignment = Alignment.CenterStart
    ) {
        SpanText(
            text = text,
            modifier = Modifier
                .fontFamily(INTER)
                .fontWeight(FontWeight.Medium)
                .color(if (isDark) Colors.White else Colors.Primary)
        )
    }
}